import { put, select } from 'redux-saga/effects';

import * as D from '../../deps';

export function* getFeedbackSuccess(action) {
  const pandoraIds = [];
  const feedbackIds = action.response.entities.feedback;
  if (feedbackIds) {
    Object.entries(feedbackIds).forEach(id => {
      pandoraIds.push(id[1].pandoraId);
    });

    const missingAnnotationTrackIds = yield select(
      D.getInDomain('catalog.utils.getIdsOfMissingAnnotations'),
      pandoraIds,
    );
    if (!missingAnnotationTrackIds.isEmpty()) {
      yield put(
        D.getInDomain('catalog.actions.annotateObjectsSimple')(missingAnnotationTrackIds.toArray()),
      );
    }
  }
}
